module.exports = __webpack_public_path__ + "img/logo.06b255ba.svg";